// https://boost.allnetru.dev/api/documentation/partner#/Events
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  GetCompanyEnrichApiResponse,
  GetEventEnrichApiResponse,
  PostPlanGenerateApiBody,
  PostPlanGenerateApiResponse,
} from './models';
import { baseQueryWithReauth } from '../../main/baseQueryWithReauth';
const ai_assistent = `ai_assistent`;

export const aiAssistent = createApi({
  reducerPath: ai_assistent,
  baseQuery: baseQueryWithReauth,
  tagTypes: [ai_assistent],
  endpoints: (build) => ({
    getCompanyEnrich: build.query<GetCompanyEnrichApiResponse, { url: string }>({
      query: ({ url }) => ({
        url: `/plan/company-enrich?url=${encodeURIComponent(url)}`,
        headers: {
          Accept: 'application/json',
        },
      }),
      providesTags: [ai_assistent],
    }),
    getEventEnrich: build.query<GetEventEnrichApiResponse, { url: string }>({
      query: ({ url }) => ({
        url: `/plan/event-enrich?url=${encodeURIComponent(url)}`,
        headers: {
          Accept: 'application/json',
        },
      }),
      providesTags: [ai_assistent],
    }),

    postPlanGenerate: build.mutation<PostPlanGenerateApiResponse, PostPlanGenerateApiBody>({
      query: (body) => ({
        url: `/plan/generate`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: body,
        providesTags: [ai_assistent],
      }),
    }),
  }),
});

export const {
  useLazyGetCompanyEnrichQuery,
  useLazyGetEventEnrichQuery,
  usePostPlanGenerateMutation,
} = aiAssistent;
